<ui-dialog
    *ngIf="activeRecord"
    [open]="isCompleteDialogOpen"
    [form]="trainingRecordForm.form"
    [header]="{ key: 'training.formTitleComplete', params: { name: activeRecord.trainingProgram.name } } | appTranslate"
    (primaryButtonPressed)="completeRecord(trainingRecordForm)"
    primaryButtonLabel="save"
    (secondaryButtonPressed)="isCompleteDialogOpen = false"
    (closing)="isCompleteDialogOpen = false"
    [stickyButtons]="true"
    [stickyHeader]="true"
>
    <app-form-training-record
        #trainingRecordForm
        [record]="activeRecord"
        (saveRecordEvent)="afterRecordSave()"
    ></app-form-training-record>
</ui-dialog>
<div class="page-container no-scroll" [class.loading]="isLoading">
    <app-header title="{{ 'training.training' | appTranslate }}" [menuService]="trainingModuleMenuService"></app-header>

    <ui-card class="scrollable-table-container" [withMargin]="false" [withSpacing]="false">
        <app-table
            *ngIf="table"
            (menuItemSelected)="menuAction($event)"
            [table]="table"
            [isResponsive]="true"
            [showOffset]="true"
            [noPadding]="true"
            [embedded]="true"
        >
            <app-empty-state
                label="{{ 'training.noTrainingLogsFound' | appTranslate }}"
                src="/assets/illustrations/chair.png"
            ></app-empty-state>
        </app-table>
    </ui-card>
</div>
